export const PRODUCTION_MODE = 'productionMode';
export const MANAGED_PRODUCTION = 'managedProduction';
export const ALT_ID_PREFIX = 'AltId';
export const OWNER_ORG_ID = 'ownerOrganizationId';
export const FILTER_PREFERENCE_KEY = 'preferenceType=Filter,entity=';
export const PINNED_TABS_PREFERENCE_KEY = 'preferenceType=PinnedTabs,entity=';
export const CUSTOM_SORT_KEY = 'custom';
export const RESOURCE_TYPE = 'resourceType';
export const PRODUCTION_ROLE_FIELDS = {
    roles: 'roles',
    productionRoles: 'productionRoles'
};

export const CONTEXT_TERM = {
    workspaceStatusReport: 'workspaceStatusReport'
};

export const PRODUCTION_ATTRIBUTES = {
    baStatus: 'baStatus'
};

export const SAVED_FILTER_PREFERENCE_KEY = {
    productionWorkspace: 'Workspace'
};

export const CUSTOM_SORT_OPTION_ID = 'custom';

export const STATE_TYPE = {
    pipeline: 'Pipeline',
    managed: 'Managed'
};

export const PRODUCTION_TYPES_OR_SUB_TYPES = {
    LIMITED_SERIES: 'Limited Series',
    SERIES: 'Series',
    SEASON: 'Season',
    EPISODE: 'Episode'
};
